import { render, staticRenderFns } from "./NavbarItemNotification.vue?vue&type=template&id=b70bec64&scoped=true&"
import script from "./NavbarItemNotification.vue?vue&type=script&lang=js&"
export * from "./NavbarItemNotification.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItemNotification.vue?vue&type=style&index=0&id=b70bec64&scoped=true&lang=css&"
import style1 from "./NavbarItemNotification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70bec64",
  null
  
)

export default component.exports